module.exports = __webpack_public_path__ + "img/science__wall.36d97e8e.svg";